// extracted by mini-css-extract-plugin
export default {"toastAlert":"ToastAlert_toastAlert__mvkP3","message":"ToastAlert_message__aJwa1"};